import { useQuery } from "@tanstack/react-query";
import { listPairs } from "app/api/pairs";
import parseError from "app/lib/parseError";
import { AxiosError } from "axios";
import { GenericErrorResponse } from "app/api/types";
import { ListPairsParams } from "app/api/pairs/types";

export const useGetPairs = (token: string, { publicKey, ...params }: ListPairsParams) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['pairs', params],
        queryFn: () => listPairs(token, { publicKey, ...params }),
    });

    return {
        data: data?.data.data,
        isLoading,
        error: error ? parseError(error as AxiosError<GenericErrorResponse>) as string : undefined,
        refetch,
    };
};  